/* eslint-disable @typescript-eslint/no-misused-promises */
import { Alert, AlertDescription, Button, Flex, FormControl, Input, useToast, Link, FormLabel, Switch } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { appApi } from '../../services/appApi'
import { ValidaCPF, ValidarEmail } from '../../Utils/Helper'
import { LayoutFull } from '../Layouts/LayoutFull'
import { Title, Container, StyledSpan } from './styles'
import LogoSah from '../../assets/LogoSah.png'

interface iLogin {
  emailCPF: string
  password: string
}

export const Login: React.FC = () => {
  const { isAuth } = useAuth()
  const toast = useToast()
  const nav = useNavigate()
  const { register, handleSubmit } = useForm()

  const [Erros, setErrors] = useState<number[]>([])

  const [CPF, setCPF] = useState(false)

  function Login(form: any): void {
    const data: iLogin = form
    setErrors([])

    if (CPF) {
      if (!ValidaCPF(data.emailCPF)) {
        setErrors(oldArray => [...oldArray, 0])
        return
      }
    } else {
      if (!ValidarEmail(data.emailCPF)) {
        setErrors(oldArray => [...oldArray, 0])
        return
      }
    }

    appApi.post('Auth/login', {
      emailCPF: CPF ? data.emailCPF.replace('.', '').replace(',', '').replace('-', '') : data.emailCPF,
      password: data.password
    })
      .then(res => {
        if (res.status === 200) {
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('logo', res.data.logo)
          appApi.defaults.headers.common.Authorization = `bearer ${res.data.token as string}`
          nav('/Colaborador')
        }
      })
      .catch(() => {
        toast({
          title: 'Credenciais inválidas',
          status: 'error',
          isClosable: false,
          position: 'bottom',
          duration: 4000
        })
      })
  }

  useEffect(() => {
    if (isAuth()) {
      nav('/Colaborador')
    }
  }, [])

  return (
    <LayoutFull>
      <Container>
        <Flex flexDirection={'column'}>
          <Flex marginBottom={'2rem'}>
            <img src={LogoSah} width={'370px'} />
          </Flex>

          <Title>
            <h2>Olá,</h2>
            <h2>Faça o seu login!</h2>
          </Title>

          <Flex marginBottom={'2rem'} flexDirection={'column'}>
            <FormControl mb='1rem' display='flex' alignItems='center' justifyContent={'end'}>
              <FormLabel mb={0} htmlFor='email-alerts' >
                Utilizar CPF?
              </FormLabel>
              <Switch onChange={(e) => setCPF(e.target.checked)} />
            </FormControl>
            {
              Erros.length > 0 && (
                <Alert marginBottom={'1rem'} borderRadius={'md'} status='error'>
                  <AlertDescription fontWeight={'semibold'}>Campos inválidos</AlertDescription>
                </Alert>
              )
            }

            <form onSubmit={handleSubmit(Login)}>
              <FormControl marginBottom={'1rem'} isInvalid={Erros.includes(0)} >
                <Input
                  borderColor={'var(--Gray4)'}
                  {...register('emailCPF')}
                  placeholder={CPF ? 'CPF' : 'Email'}
                  id='lb-1'
                />
              </FormControl>

              <FormControl marginBottom={'1rem'} isInvalid={Erros.includes(1)} >
                <Input
                  borderColor={'var(--Gray4)'}
                  type={'password'}
                  {...register('password')}
                  placeholder='Senha'
                  id='lb-2'
                />
              </FormControl>

              <Flex flexDirection={'column'} marginTop={'2rem'}>
                <Flex justifyContent={'center'} marginBottom={'.5rem'}>
                  <StyledSpan onClick={() => nav('/Usuario/EsqueciSenha')}>Não sei minha senha</StyledSpan>
                </Flex>

                <Flex flexDirection={'column'} marginBottom={'.5rem'}>
                  <Button
                    bg={'var(--DegradeAzul)'}
                    type='submit'
                    size={'lg'}
                    _hover={{ bg: 'var(--DegradeAzul)' }}
                    _active={{ bg: 'var(--DegradeAzul)' }}
                  >Entrar</Button>
                </Flex>

                <Flex justifyContent={'center'} mt={5} marginBottom={'.5rem'}>
                  <Link color={'var(--c7)'} onClick={() => nav('/Privacidade')}>Política de privacidade</Link>
                </Flex>
              </Flex>
            </form>
          </Flex>
        </Flex>
      </Container>
    </LayoutFull>
  )
}
